/** Reserved key inside an integration's config object that holds the root-level (non-route) configuration */
export const _rootConfig = "_rootConfig";
/** Route key used while an integration route is still being created and has no real name yet */
export const newRouteKey = "new";
/** Route key of the fallback/default integration route */
export const defaultRoute = "default";
